import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import image from "images/devices/julio-promotion.png";

const serviceUuid = "00001400-0000-1000-8000-00805f9b34fb";
const VIBRATION_MOTOR_UUID = 0x1401;
const THRUSTING_MOTOR_UUID = 0x1402;
const CHANGE_NAME_UUID = 0x1404;

const PERIOD_DURATION_MS = 100;

const names = ["Julio"];

const convertValueToUint16 = (value) => {
  const lowByte = value & 0xff;
  const highByte = (value >> 8) & 0xff;
  return [highByte, lowByte];
};

// Can't send 0 as a value or else device will turn off
const convertPercentToCommandValue = (percent) => {
  return Math.max(1, Math.round((percent / 100) * 255));
};

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class Julio extends BaseDeviceWrapper {
  constructor(device) {
    super(device, serviceUuid, VIBRATION_MOTOR_UUID, image);
  }

  static get deviceNames() {
    return names;
  }

  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "Kiiroo";
  }

  async connect() {
    await super.connect(async () => {
      this.thrustingChar = await this.sensorService.getCharacteristic(
        THRUSTING_MOTOR_UUID
      );
    });
  }

  async write(percent) {
    const value = Math.max(0, Math.min(100, Math.round(percent)));
    const commandValue = convertPercentToCommandValue(value);
    const array = new Uint8Array([
      0x00,
      ...convertValueToUint16(PERIOD_DURATION_MS),
      value ? 0xff : 0x00,
      commandValue,
      commandValue,
    ]);
    return this.motorChar.writeValue(array);
  }

  async setDeviceName(newName) {
    const hexDeviceName = newName.split("").map((c) => c.charCodeAt(0));
    const array = new Uint8Array(hexDeviceName);
    const charChangeName = await this.sensorService.getCharacteristic(
      CHANGE_NAME_UUID
    );
    return charChangeName.writeValue(array);
  }
}
